import plusIcon from '../../../../../_metronic/images/fitler-plus-blue.svg'
import Prompts from './CreateModalComponents/Prompts'
import React, {useState, useEffect} from 'react'
import uuid from 'react-uuid'
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd'
import './CreatePrompts.css'
import {GET_ALL_TAGS} from '../../../../../utils/GraphQLAPI'
import Dropdown from 'react-bootstrap/Dropdown'
import ParseExcel from './ParseExcel'
import {useLazyQuery} from '@apollo/client'
import clsx from 'clsx'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
import Tooltip from '../../../../sharedComponent/CustomTooltip/Tooltip'

interface TabConfig {
  label: string
  value: string
}
const CreatePrompts = ({
  payload,
  setPayload,
  languagesSelected,
  dataFromGetScript,
  availableLanguages,
  setSelectedLanguage,
  modalConfig,
  isSolarProduct,
}: any) => {
  const [currentLanguageId, setCurrentLanguageId] = useState<any>()
  const [selectedLanguageId, setSelectedLanguageId] = useState()
  const [dualQuestions, setDualQuestions] = useState<any>([])
  const [electricQuestions, setElectricQuestions] = useState<any>([])
  const [gasQuestions, setGasQuestions] = useState<any>([])
  const [solarQuestions, setSolorQuestions] = useState<any>([])
  const [tagList, setTagList] = useState([])
  const [questions, setQuestions] = useState<any>([])
  const [tab, setTab] = useState(
    isSolarProduct ? GLOBAL_CONSTANTS.scriptType.solar : GLOBAL_CONSTANTS.scriptType.dual
  )
  const [getAllTags, {data}] = useLazyQuery(GET_ALL_TAGS)

  useEffect(() => {
    getAllTags()
  }, [])

  useEffect(() => {
    setSelectedLanguageId(languagesSelected[0]?.value)
    const selectedLanguagequestions = payload?.scriptQuestions?.filter(
      (item: any) => item?.languageId === selectedLanguageId
    )[0]?.questions
    setDualQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.dual
      )
    )
    setElectricQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.electric
      )
    )
    setGasQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.gas
      )
    )
    setSolorQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.solar
      )
    )
  }, [languagesSelected])

  useEffect(() => {
    setCurrentLanguageId(
      payload?.scriptQuestions?.find(({languageId}: any) => languageId === selectedLanguageId)
    )
  }, [selectedLanguageId])

  const handleSelectChange = (value: any) => {
    setSelectedLanguageId(value)
  }
  useEffect(() => {
    const selectedLanguagequestions = payload?.scriptQuestions?.filter(
      (item: any) => item?.languageId === selectedLanguageId
    )[0]?.questions
    setDualQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.dual
      )
    )
    setElectricQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.electric
      )
    )
    setGasQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.gas
      )
    )
    setSolorQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.solar
      )
    )
  }, [selectedLanguageId])

  const addPrompts = () => {
    let id = uuid()
    setPayload((prev: any) => {
      return {
        ...prev,
        scriptQuestions: prev.scriptQuestions.map((eachLanguage: any) => {
          if (eachLanguage.languageId === selectedLanguageId) {
            eachLanguage.questions.push({
              questionType: 'SPEECH_ONLY',
              id: id,
              scriptLangId: `${eachLanguage.languageId}`,
              //NOTE: if you change the default value of question please the
              description: '',
              continueCall: false,
              scriptType: tab,
            })
            return eachLanguage
          }
          return eachLanguage
        }),
      }
    })
    if (tab === GLOBAL_CONSTANTS.scriptType.dual) {
      setDualQuestions((prev: any) => [
        ...prev,
        {
          questionType: 'SPEECH_ONLY',
          id: id,
          scriptLangId: currentLanguageId.languageId,
          //NOTE: if you change the default value of question please the
          description: '',
          continueCall: false,
          scriptType: tab,
        },
      ])
    } else if (tab === GLOBAL_CONSTANTS.scriptType.electric) {
      setElectricQuestions((prev: any) => [
        ...prev,
        {
          questionType: 'SPEECH_ONLY',
          id: id,
          scriptLangId: currentLanguageId.languageId,
          //NOTE: if you change the default value of question please the
          description: '',
          continueCall: false,
          scriptType: tab,
        },
      ])
    } else if (tab === GLOBAL_CONSTANTS.scriptType.gas) {
      setGasQuestions((prev: any) => [
        ...prev,
        {
          questionType: 'SPEECH_ONLY',
          id: id,
          scriptLangId: currentLanguageId.languageId,
          //NOTE: if you change the default value of question please the
          description: '',
          continueCall: false,
          scriptType: tab,
        },
      ])
    } else if (tab === GLOBAL_CONSTANTS.scriptType.solar) {
      setSolorQuestions((prev: any) => [
        ...prev,
        {
          questionType: 'SPEECH_ONLY',
          id: id,
          scriptLangId: currentLanguageId.languageId,
          //NOTE: if you change the default value of question please the
          description: '',
          continueCall: false,
          scriptType: tab,
        },
      ])
    }
  }

  const editQuestion = (value: any, questionType: any, id: any, continueCall: boolean) => {
    setPayload((prev: any) => {
      return {
        ...prev,
        scriptQuestions: prev.scriptQuestions?.map((eachLanguage: any) => {
          if (eachLanguage.languageId === selectedLanguageId) {
            return {
              ...eachLanguage,
              questions: eachLanguage.questions?.map((question: any) => {
                if (question.id === id) {
                  return {
                    ...question,
                    description: value,
                    questionType,
                    continueCall,
                  }
                }
                return question
              }),
            }
          }
          return eachLanguage
        }),
      }
    })
    if (tab === GLOBAL_CONSTANTS.scriptType.dual) {
      setDualQuestions((prev: any) =>
        prev.map((question: any) => {
          if (question.id === id) {
            return {
              ...question,
              description: value,
              questionType,
              continueCall,
            }
          }

          return question
        })
      )
    } else if (tab === GLOBAL_CONSTANTS.scriptType.electric) {
      setElectricQuestions((prev: any) =>
        prev.map((question: any) => {
          if (question.id === id) {
            return {
              ...question,
              description: value,
              questionType,
              continueCall,
            }
          }

          return question
        })
      )
    } else if (tab === GLOBAL_CONSTANTS.scriptType.gas) {
      setGasQuestions((prev: any) =>
        prev.map((question: any) => {
          if (question.id === id) {
            return {
              ...question,
              description: value,
              questionType,
              continueCall,
            }
          }

          return question
        })
      )
    } else if (tab === GLOBAL_CONSTANTS.scriptType.solar) {
      setSolorQuestions((prev: any) =>
        prev.map((question: any) => {
          if (question.id === id) {
            return {
              ...question,
              description: value,
              questionType,
              continueCall,
            }
          }

          return question
        })
      )
    }
  }

  const deleteQuestion = (id: any) => {
    setPayload((prev: any) => {
      return {
        ...prev,
        scriptQuestions: prev.scriptQuestions?.map((eachLanguage: any) => {
          if (eachLanguage.languageId === selectedLanguageId) {
            return {
              ...eachLanguage,
              questions: eachLanguage.questions.filter((question: any) => question.id !== id),
            }
          }
          return eachLanguage
        }),
        deleteScriptQuestions: dataFromGetScript.existingQuestions.includes(id)
          ? [...prev.deleteScriptQuestions, id]
          : [...prev.deleteScriptQuestions],
      }
    })
    if (tab === GLOBAL_CONSTANTS.scriptType.dual) {
      setDualQuestions((prev: any) => prev.filter((question: any) => question.id !== id))
    } else if (tab === GLOBAL_CONSTANTS.scriptType.electric) {
      setElectricQuestions((prev: any) => prev.filter((question: any) => question.id !== id))
    } else if (tab === GLOBAL_CONSTANTS.scriptType.gas) {
      setGasQuestions((prev: any) => prev.filter((question: any) => question.id !== id))
    } else if (tab === GLOBAL_CONSTANTS.scriptType.solar) {
      setSolorQuestions((prev: any) => prev.filter((question: any) => question.id !== id))
    }
  }

  const handleDrop = (droppedItem: any) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return

    let updatedList: any = []
    if (tab === GLOBAL_CONSTANTS.scriptType.dual) {
      updatedList = dualQuestions
      // Remove dragged item
      const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)
      // Add dropped item
      updatedList.splice(droppedItem.destination.index, 0, reorderedItem)
      setDualQuestions(updatedList)
      setPayload((prev: any) => {
        return {
          ...payload,
          scriptQuestions: prev.scriptQuestions?.map((question: any) => {
            if (question.languageId === currentLanguageId.languageId) {
              return {
                ...question,
                questions: [
                  ...updatedList,
                  ...electricQuestions,
                  ...gasQuestions,
                  ...solarQuestions,
                ],
              }
            } else {
              return {...question}
            }
          }),
        }
      })
    } else if (tab === GLOBAL_CONSTANTS.scriptType.electric) {
      updatedList = electricQuestions
      // Remove dragged item
      const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)
      // Add dropped item
      updatedList.splice(droppedItem.destination.index, 0, reorderedItem)
      updatedList = electricQuestions
      setElectricQuestions(updatedList)
      setPayload((prev: any) => {
        return {
          ...payload,
          scriptQuestions: prev.scriptQuestions?.map((question: any) => {
            if (question.languageId === currentLanguageId.languageId) {
              return {
                ...question,
                questions: [...dualQuestions, ...updatedList, ...gasQuestions, ...solarQuestions],
              }
            } else {
              return {...question}
            }
          }),
        }
      })
    } else if (tab === GLOBAL_CONSTANTS.scriptType.gas) {
      updatedList = gasQuestions
      // Remove dragged item
      const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)
      // Add dropped item
      updatedList.splice(droppedItem.destination.index, 0, reorderedItem)

      setGasQuestions(updatedList)
      setPayload((prev: any) => {
        return {
          ...payload,
          scriptQuestions: prev.scriptQuestions?.map((question: any) => {
            if (question.languageId === currentLanguageId.languageId) {
              return {
                ...question,
                questions: [
                  ...dualQuestions,
                  ...electricQuestions,
                  ...updatedList,
                  ...solarQuestions,
                ],
              }
            } else {
              return {...question}
            }
          }),
        }
      })
    } else if (tab === GLOBAL_CONSTANTS.scriptType.solar) {
      updatedList = solarQuestions
      // Remove dragged item
      const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)
      // Add dropped item
      updatedList.splice(droppedItem.destination.index, 0, reorderedItem)

      setGasQuestions(updatedList)
      setPayload((prev: any) => {
        return {
          ...payload,
          scriptQuestions: prev.scriptQuestions?.map((question: any) => {
            if (question.languageId === currentLanguageId.languageId) {
              return {
                ...question,
                questions: [
                  ...dualQuestions,
                  ...electricQuestions,
                  ...updatedList,
                  ...solarQuestions,
                ],
              }
            } else {
              return {...question}
            }
          }),
        }
      })
    }
  }
  useEffect(() => {
    const tagsList: any = []
    for (const key in data?.getAllTags?.tags) {
      tagsList.push({
        name: key,
        description: data?.getAllTags?.tags[key].description,
        value: data?.getAllTags?.tags[key].value,
      })
    }
    setTagList(tagsList)
  }, [data])

  const tabsList = [
    {label: 'Both Electric and Gas', value: GLOBAL_CONSTANTS.scriptType.dual},
    {label: 'Electric', value: GLOBAL_CONSTANTS.scriptType.electric},
    {label: 'Gas', value: GLOBAL_CONSTANTS.scriptType.gas},
    {label: 'Solar', value: GLOBAL_CONSTANTS.scriptType.solar},
  ]
  const renderList = (tabConfig: TabConfig) => {
    return (
      <li className='nav-item' key={tabConfig.value}>
        <div
          className={clsx('tab-pane nav-link cursor-pointer text-gray-600 fs-4', {
            active: tab === tabConfig.value,
          })}
          role='tab'
          onClick={() => setTab(tabConfig.value)}
        >
          {tabConfig.label}
        </div>
      </li>
    )
  }

  return (
    <>
      <div className='container-xxl d-flex flex-stack  w-100 mb-5 '>
        <div className='d-flex'>
          <h4 className='text-gray-800 fs-3 fw-bold me-2'>Prompts List</h4>
          <Dropdown drop='down'>
            <Dropdown.Toggle
              as={'a'}
              className='cursor-pointer text-decoration-underline fs-7 fw-semibold'
              id='dropdown-basic'
            >
              View All Tags
            </Dropdown.Toggle>

            <Dropdown.Menu className='min-w-325px fixed-height-body'>
              <table className='table table-row-bordered table-row-gray-300 gy-2 gx-7'>
                <tr className='fw-bolder'>
                  <th className='text-gray-700'>Tags</th>
                  <th className='text-gray-700'>Description</th>
                </tr>
                <tbody>
                  {data &&
                    tagList.map((tag: any) => {
                      return (
                        <tr>
                          <td className='text-gray-700 fs-7 fw-semibold'>{tag?.value}</td>
                          <td className='text-gray-700 fs-7 fw-semibold'>{tag?.description}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <select
            className='form-select form-select-solid pe-17 bg-f4f4f4'
            value={selectedLanguageId}
            onChange={(e) => handleSelectChange(e.target.value)}
            aria-label='Select example'
          >
            {languagesSelected?.map((language: any) => {
              return (
                <option key={language.label} value={language.value}>
                  {language.label}
                </option>
              )
            })}
          </select>
          <button
            className='btn btn-active-light-primary btn-light-primary fs-6 px-5 py-3'
            onClick={() => addPrompts()}
          >
            <div className='d-flex '>
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1 me-0' />
              <div className='fs-6 w-100px'>Add Prompts</div>
            </div>
          </button>
          {modalConfig.mode === 'create' && (
            <ParseExcel
              setQuestions={setQuestions}
              payload={payload}
              setPayload={setPayload}
              languagesSelected={languagesSelected}
              availableLanguages={availableLanguages}
              setSelectedLanguage={setSelectedLanguage}
              setDualQuestions={setDualQuestions}
              setSolorQuestions={setSolorQuestions}
              setElectricQuestions={setElectricQuestions}
              setGasQuestions={setGasQuestions}
              isSolarProduct={isSolarProduct}
            />
          )}
        </div>
      </div>
      <div className='tab d-flex flex-row justify-content-between mb-2'>
        <ul
          className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
          role='tablist'
        >
          {tabsList
            .filter((tabConfig) =>
              isSolarProduct ? tabConfig.label === 'Solar' : tabConfig.label !== 'Solar'
            )
            .map(renderList)}
        </ul>
      </div>
      <div className='tab-content pt-3'>
        <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.dual})}>
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId='list-container'>
              {(provided) => (
                <div
                  className='list-container min-h-300px d-flex flex-column gap-5 fixed-height-body'
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {dualQuestions?.map((question: any, index: number) => (
                    <Draggable key={index} draggableId={String(index)} index={index}>
                      {(provided) => (
                        <div
                          className='item-container'
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <>
                            <Prompts
                              key={question?.id}
                              position={index + 1}
                              questionLength={questions.length}
                              questionType={question.questionType}
                              continueCall={question.continueCall}
                              description={question.description
                                .replaceAll('{', '[')
                                .replaceAll('}', ']')}
                              id={question.id}
                              setPayload={setPayload}
                              onQuestionEdit={editQuestion}
                              onDeleteQuestion={deleteQuestion}
                              tagList={tagList}
                            />
                          </>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.electric})}>
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId='list-container'>
              {(provided) => (
                <div
                  className='list-container min-h-300px d-flex flex-column gap-5 fixed-height-body'
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {electricQuestions?.map((question: any, index: number) => (
                    <Draggable key={index} draggableId={String(index)} index={index}>
                      {(provided) => (
                        <div
                          className='item-container'
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <>
                            <Prompts
                              key={question?.id}
                              position={index + 1}
                              questionLength={questions.length}
                              questionType={question.questionType}
                              continueCall={question.continueCall}
                              description={question.description
                                .replaceAll('{', '[')
                                .replaceAll('}', ']')}
                              id={question.id}
                              setPayload={setPayload}
                              onQuestionEdit={editQuestion}
                              onDeleteQuestion={deleteQuestion}
                              tagList={tagList}
                            />
                          </>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.gas})}>
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId='list-container'>
              {(provided) => (
                <div
                  className='list-container min-h-300px d-flex flex-column gap-5 fixed-height-body'
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {gasQuestions?.map((question: any, index: number) => (
                    <Draggable key={index} draggableId={String(index)} index={index}>
                      {(provided) => (
                        <div
                          className='item-container'
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <>
                            <Prompts
                              key={question?.id}
                              position={index + 1}
                              questionLength={questions.length}
                              questionType={question.questionType}
                              continueCall={question.continueCall}
                              description={question.description
                                .replaceAll('{', '[')
                                .replaceAll('}', ']')}
                              id={question.id}
                              setPayload={setPayload}
                              onQuestionEdit={editQuestion}
                              onDeleteQuestion={deleteQuestion}
                              tagList={tagList}
                            />
                          </>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.solar})}>
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId='list-container'>
              {(provided) => (
                <div
                  className='list-container min-h-300px d-flex flex-column gap-5 fixed-height-body'
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {solarQuestions?.map((question: any, index: number) => (
                    <Draggable key={index} draggableId={String(index)} index={index}>
                      {(provided) => (
                        <div
                          className='item-container'
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <>
                            <Prompts
                              key={question?.id}
                              position={index + 1}
                              questionLength={questions.length}
                              questionType={question.questionType}
                              continueCall={question.continueCall}
                              description={question.description
                                .replaceAll('{', '[')
                                .replaceAll('}', ']')}
                              id={question.id}
                              setPayload={setPayload}
                              onQuestionEdit={editQuestion}
                              onDeleteQuestion={deleteQuestion}
                              tagList={tagList}
                            />
                          </>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </>
  )
}

export default CreatePrompts
